export default __webpack_public_path__ + "static/5-db03e7d2d1eaee2c21eb0764b672b6bf.jpeg";